import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import BaseToast from './baseToast';

import { actionCreators as toastAlertsCreators } from 'react/api/actions/toastAlerts';
import { actionCreators as integrationActionsCreators } from 'react/api/actions/integrations';
import { getResourceTo } from 'react/utils/chatUtils';

const LogsFeedbackNotification = ({
  toastData
}) => {
  const dispatch = useDispatch();

  function removeThisToast() {
    dispatch(toastAlertsCreators.removeToast({ id: toastData.get('id') }));
  }

  function handleSeeLogsDetails() {
    const records = toastData.getIn(['data', 'records'])?.toJS();
    const integrationId = toastData.getIn(['data', 'configuration']);
    const pageId = toastData.getIn(['data', 'pageId']);

    const payload = {
      records,
      integrationId,
      pageId
    };

    dispatch(integrationActionsCreators.openRetriedLogsPage(payload));

    removeThisToast();
  }

  const header = () => (
    <>
      <h4>
        <span className="info-icon" />
        {getResourceTo(toastData.getIn(['data', 'title']))}
      </h4>
      <span 
        data-testid={`remove-toast-${toastData.get('id')}`}
        className="close-icon" 
        onClick={removeThisToast} 
        alt="Close Icon" 
      />
    </>
  );

  const body = () => (
    <>
      <p>{getResourceTo('Integration.retryToastFeedback.description')}</p>
      <br></br>
      <p>
        <b>{`${getResourceTo('Integration.retryToastFeedback.totalRecords')}: `}</b>
        {toastData.getIn(['data', 'totalRecords'])}
      </p>
      <p>
        <b>{`${getResourceTo('Integration.retryToastFeedback.syncedRecords')}: `}</b>
        {toastData.getIn(['data', 'syncedRecords'])}
      </p>
    </>
  );

  const footer = () => (
    <>
      <input
        data-testid={`confirmAction-toast-${toastData.get('id')}`}
        type="button"
        value={getResourceTo('Integration.retryToastFeedback.viewResults')}
        onClick={handleSeeLogsDetails}
      />
    </>
  );

  return (
    <BaseToast
      toastId={toastData.get('id')}
      className={String(toastData.get('type'))}
      header={header()}
      body={body()}
      footer={footer()}
      data-testid={`logsFeedback-toast-${toastData.get('type')}-${toastData.get('id')}`}
    />
  );
};

LogsFeedbackNotification.propTypes = {
  toastData: PropTypes.object.isRequired
};

export default LogsFeedbackNotification;
